import type { ReactNode } from 'react';
import './StatCard.css';

interface Props {
  label: string;
  value: ReactNode;
  accent?: string;
  trailing?: ReactNode;
}

export function StatCard({ label, value, accent, trailing }: Props) {
  return (
    <div className="stat-card glass">
      <div className="label">{label}</div>
      <div className="stat-card__value" style={accent ? { color: accent } : undefined}>
        {value}
      </div>
      {trailing && <div className="stat-card__trailing">{trailing}</div>}
    </div>
  );
}
